// extracted by mini-css-extract-plugin
export default {"header":"MPTLeLabo_header__EPGRf","band":"MPTLeLabo_band__N-9I8","visual":"MPTLeLabo_visual__haOUI"};